import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { FeaturesService } from '@services/features.service';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'vnm-feature-gate',
  templateUrl: 'feature-gate.component.html'
})
export class FeatureGateComponent implements OnInit {
  @Input() feature: string;
  @ContentChild(TemplateRef) gated: TemplateRef<any>;

  enabled$: Observable<boolean>;

  constructor(private features: FeaturesService) {}

  ngOnInit() {
    this.enabled$ = this.features.featureEnabled(this.feature).pipe(startWith(false));
  }
}
